export class Viol3formatService {

    static formatRedovisninghanvisningTooltip(redovisningshanvisning: any): string {
        if (!redovisningshanvisning) {
            return "";
        }

        return `Identitet: ${redovisningshanvisning.identitet}\
        Inmätningshandelssortiment: ${redovisningshanvisning.inmatningshandelssortiment}
        Namn: ${redovisningshanvisning.namn}
        Kollektiv: ${redovisningshanvisning.kollektiv ? "Ja" : "Nej"}
        Kollektivnummer: ${redovisningshanvisning.kollektivnummer || "-"}
        Kontraktskedjestyrning: ${redovisningshanvisning.kontraktskedjestyrning || "-"}
        Kontraktskedja: ${redovisningshanvisning.aktuellKontraktskedja?.identitet || "-"}
        Befraktare: ${redovisningshanvisning.befraktare || "-"}
        Mottagare: ${redovisningshanvisning.mottagare || "-"}
        Kund: ${redovisningshanvisning.aktuellKontraktskedja?.kund || "-"}
        Anskaffningsform: ${redovisningshanvisning.anskaffningsformer?.join(", ") || "-"}
        Transportslag: ${redovisningshanvisning.transportslag || "-"}`;
    }
}
